<div class="sentiment-analysis" [ngClass]="{ 'connect-section': !inCreateCampaign, 'create-section': inCreateCampaign }">
  <div>
    <p>
      Available in
      <a href="https://huggingface.co/joeddav/xlm-roberta-large-xnli#intended-usage" target="_blank">15 languages</a>
    </p>
  </div>
  <div class="sentiment-analysis-type">
    <p>Let's answer to</p>
    <div class="d-flex">
      <button type="button" class="sentiment-analysis-btn" [class.active]="selectedSentiment === 'positive'" (click)="selectSentiment('positive')">
        😀 POSITIVE</button
      ><button type="button" class="sentiment-analysis-btn" [class.active]="selectedSentiment === 'neutral'" (click)="selectSentiment('neutral')">
        😐 NEUTRAL</button
      ><button type="button" class="sentiment-analysis-btn" [class.active]="selectedSentiment === 'negative'" (click)="selectSentiment('negative')">
        🙁 NEGATIVE
      </button>
    </div>
    <p>comments !</p>
  </div>
</div>

<div class="selected-sentiment">
  <span class="margin-10">BUILD THE ANSWERS TO </span
  ><span class="selected-sentiment-title"> {{ emojiSelector[selectedSentiment] }} {{ selectedSentiment }}</span
  ><span>COMMENTS</span>
</div>
